export function formatCompactUSD(number: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
        notation: 'compact',
        compactDisplay: 'short',
        roundingMode: 'floor',
    }).format(number);
}

export function formatUSD(number: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
    }).format(number);
}

export function formatNumber(number: number): string {
    return new Intl.NumberFormat('en-US').format(number);
}
